var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandshake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0152 23.7856L42.1875 26.1995L35.9375 14.2303L40.8143 11.7919C41.1807 11.6087 41.6044 11.5767 41.9941 11.7029C42.3839 11.829 42.7085 12.1031 42.8981 12.4662L47.7014 21.6649C47.7975 21.8488 47.8559 22.05 47.8734 22.2568C47.8908 22.4635 47.8669 22.6717 47.803 22.8691C47.7391 23.0666 47.6365 23.2493 47.5013 23.4066C47.366 23.564 47.2008 23.6928 47.0152 23.7856V23.7856Z",
    stroke: "#7D66FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81249 25.9905L2.98482 23.5767C2.79923 23.4839 2.63397 23.355 2.49871 23.1977C2.36344 23.0403 2.26087 22.8576 2.19699 22.6602C2.1331 22.4627 2.10918 22.2546 2.12662 22.0478C2.14406 21.841 2.20251 21.6398 2.29855 21.4559L7.10186 12.2572C7.29147 11.8941 7.6161 11.62 8.00584 11.4939C8.39559 11.3677 8.81928 11.3997 9.18567 11.5829L14.0625 14.0213L7.81249 25.9905Z",
    stroke: "#7D66FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 26.1996L39.0625 29.8554L31.8756 37.0424C31.6848 37.2332 31.4478 37.3713 31.1878 37.4433C30.9278 37.5153 30.6535 37.5188 30.3917 37.4534L19.072 34.6234C18.8597 34.5704 18.6609 34.4733 18.4885 34.3384L7.8125 25.9902",
    stroke: "#7D66FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0624 29.8555L30.4687 23.6055L27.9686 25.4805C26.8868 26.2919 25.571 26.7305 24.2187 26.7305C22.8663 26.7305 21.5505 26.2919 20.4687 25.4805L19.4099 24.6864C19.2308 24.5521 19.0827 24.3809 18.9755 24.1843C18.8684 23.9878 18.8047 23.7705 18.7888 23.5472C18.773 23.3239 18.8053 23.0998 18.8836 22.89C18.9618 22.6803 19.0843 22.4899 19.2426 22.3316L26.886 14.6881C27.0311 14.543 27.2033 14.4279 27.3929 14.3494C27.5825 14.2709 27.7857 14.2305 27.9909 14.2305H35.9374",
    stroke: "#7D66FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1746 14.0217L24.198 11.0996C24.5561 10.9952 24.9396 11.0223 25.2794 11.1761L32.0311 14.2311",
    stroke: "#7D66FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 41.5745L15.9884 40.1029C15.7495 40.0432 15.5281 39.9278 15.3423 39.7663L10.9375 35.9375",
    stroke: "#7D66FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/Handshake.65f28a79a30c1bfe96dfd0feb36adca8.svg";
export { ForwardRef as ReactComponent };